<template>
    <div v-if="data" class="flex min-h-screen text-center">
        <ContentRenderer :value="data">
            <div
                class="bg-white text-fjell py-20 px-4 md:px-8 mx-4 my-auto rounded-xl shadow-xl max-w-2xl md:mx-auto"
            >
                <div class="size-20 lg:size-44 bg-vann rounded-full flex mx-auto mb-8">
                    <svg-icon name="logo" class="size-18 lg:size-40" />
                </div>
                <h1 class="mb-2">{{ data?.title }}</h1>
                <p>{{ data?.intro }}</p>
                <span class="block text-center mt-8 font-lead mb-4">{{ data?.romkode }}</span>
                <div class="relative flex items-center justify-center">
                    <template v-for="i in 6">
                        <input maxlength="1" ref="inputs" @keyup="checkInput($event, i - 1)" />
                        <span v-if="i === 3" class="mx-3 text-frost font-bold">–</span>
                    </template>
                </div>
                <button class="btn bg-vann text-white mt-8" @click="joinRoom()">
                    {{ data?.blimed }}
                </button>
            </div>
        </ContentRenderer>
    </div>
</template>

<script setup lang="ts">
definePageMeta({
    layout: 'client'
});
useSeoMeta({ robots: 'noindex, nofollow' });
const { locale } = useI18n();
const { data } = await useAsyncData('data', () => queryContent(`${locale.value}/start`).findOne());
let code = computed(() => {
    const tmp = inputs.value.map(i => i.value.toUpperCase());
    tmp.splice(3, 0, '-');
    return tmp.join('');
});

const inputs = ref<HTMLInputElement[]>([]);

const checkInput = (ev: KeyboardEvent, num: number) => {
    if (!inputs.value) {
        return;
    }
    if (ev.key === 'Backspace') {
        inputs.value[num].value = '';
        if (num !== 0) {
            inputs.value[num - 1].focus();
        }
    } else {
        if (num === inputs.value.length - 1 && inputs.value[num].value !== '') {
            return true;
        } else if (ev.key >= '0' && ev.key <= '9') {
            inputs.value[num].value = ev.key;
            if (num !== inputs.value.length - 1) inputs.value[num + 1].focus();
        } else if (ev.keyCode > 64 && ev.keyCode < 91) {
            inputs.value[num].value = String.fromCharCode(ev.keyCode);
            if (num !== inputs.value.length - 1) inputs.value[num + 1].focus();
        }
    }
};

const joinRoom = () => {
    if (code.value.length !== 7) {
        return alert('Ugyldig kode');
    }
    location.href = `/rom/${code.value}`;
};
</script>

<style scoped>
input {
    @apply size-10
        md:size-14
        text-8
        border
        mx-0.5
        p-0
        text-center
        border-frost-30
        text-vann
        uppercase;
}
</style>
